import React from "react";
import {useSelector} from "react-redux";
import CustomVoting from "../../../../custom/flavewindhund36522/exhibition/components/video_room/custom_voting";

const Flavewindhund36522CustomVoting = ({node, options}) => {
  const videoRoomIdentifier = null
  const videoRoom = useSelector(state => state.videoRooms.find(vr => videoRoomIdentifier ? vr.identifier == videoRoomIdentifier : vr.identifier == "new_live"))
  const questionEvent = useSelector(state => videoRoom ? state.events.find(event => event.id == videoRoom.event_id) : null)

  return <CustomVoting event={questionEvent} videoRoom={videoRoom}/>
}

export default Flavewindhund36522CustomVoting